<template>
  <div class="map" v-on:click="clickHandler">
     <SvgView  />
     <SvgMap style="opacity: 0" />
     <div class="popup" v-if="metroStop || startImage" @click="closeVideoPlayer()">
       <VideoPlayer
         v-bind:vimeoId="metroStop"
         v-on:close="closeVideoPlayer"
       />
       <div v-if="startImage" class="startImage" @click="closeVideoPlayer()"></div>
     </div>
  </div>
</template>

<script>
  import SvgMap from '../assets/ludo_mao_v12.svg';
  import SvgView from '../assets/ludo_mao_v12_view.svg';
  import VideoPlayer from './VideoPlayer'
  import stops from '../content/stops'

  export default {
    name: 'MetroMap',
    components: {
      SvgMap,SvgView, VideoPlayer
    },
    data() {
      return {
        svg: '',
        metroStop: null,
        startImage: false,
      };
    },
    methods: {
      closeVideoPlayer() {
        this.metroStop = null;
        this.startImage= false
      },
      clickHandler(event) {
        console.log(event.srcElement.id) //eslint-disable-line
        if(event.srcElement.hasAttribute('id')){
          const stopId = event.srcElement.id;
          if(stopId === 'Paradigma_1'){
            this.startImage = true
          }else{
            this.startImage = false
          }

          const validStop = stops.find(function(stop) {
            if(stopId === stop.id){
              return stop
            }
          })

          if(validStop){
            this.metroStop = validStop.vimeo.replace("https://vimeo.com/", "");
          }
        }
      }
    },
    mounted() {
      if(!window.loggedIn) {
          this.$router.replace({ name: "login" });
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
svg {
  top: 0;
  left: 0;
  position: absolute;
}
.popup{
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.25);
}
  .startImage{
    width: 640px;
    height:320px;
    background: transparent url("../assets/PastedGraphic-1.png") center center no-repeat;
    background-size: contain;
    margin: 40px auto 0 auto;
  }
</style>
